import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PdfDetail } from '../models/pdf-detail';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';



@Component({
  selector: 'app-pdf-to-table',
  templateUrl: './pdf-to-table.component.html',
  styleUrls: ['./pdf-to-table.component.css']
})
export class PdfToTableComponent implements OnInit {

  constructor(private http : HttpClient, private modalService: BsModalService) { }

  ngOnInit() {
    this.convertedAsCsv="";
    this.converted="";
  }

  fileName : string;

  convertedAsCsv : string;

  converted : string;
  modalRef : BsModalRef;

  lastCsvHeader: string;

  lineFeed="\r\n";

  convert(template)
  {
    if (this.pdfDetails==undefined)
      return;

    var result=this.generateJSON();

    this.converted=this.JsonToCsv(result);

    this.modalRef=this.modalService.show(template);
    //console.log(this.converted);
  }

  download()
  {
    this.downloadHelper(this.converted, this.fileName+".csv")
    this.modalRef.hide();
  }
  downloadSaved()
  {
    this.downloadHelper(this.convertedAsCsv, this.fileName+".csv")
    this.modalRef.hide();
  }

  downloadHelper(contentToDownload: string, fileName:string)
  {
    let csvContent = 'data:text/csv;charset=utf-8,'+contentToDownload;
    const encodedUri = csvContent;
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();    

  }

  showSaved(template)
  {
    this.modalRef=this.modalService.show(template);
  }

  save()
  {
    this.modalRef.hide();

    let counter=0;

    this.converted.split("\r\n").forEach(line => {

      if(line)
      {

      if (counter==0)
      {
        if (line!=this.lastCsvHeader)
        {
          this.convertedAsCsv+=line+this.lineFeed;
          this.lastCsvHeader=line;
        }
      }
      else
      {
        this.convertedAsCsv+=line+this.lineFeed;
      }
      counter++;
      }
  });

  }

  clear()
  {
    this.modalRef.hide();
    this.convertedAsCsv="";

  }
  resetTemplate()
  {
    if (this.pdfDetails==undefined)
      return;

    this.pdfDetails.forEach(det=>{
      det.IsReference=false;
      det.Alignment=undefined;
      det.FieldNameDetail=undefined;
      det.FieldNameHeader=undefined;
      det.Parameters=undefined;
    });
  }

  generateJSON() : any
  {

    let result:any ={};
    result.Details =[];


    this.setIsDetailOn(this.pdfDetails);

    //console.log(this.pdfDetails);

    //extract the header fields
    this.pdfDetails.filter(p=> p.FieldNameHeader).forEach(det => {
      result[det.FieldNameHeader]=det.Text;
    });


    //find the reference field, if more, only the first on is used
    let referenceInTemplate=this.findReferenceField(this.pdfDetails);

    let referenceName=referenceInTemplate.FieldNameDetail ? referenceInTemplate.FieldNameDetail : "Reference";
    let templateDetails=this.pdfDetails.filter(det=>det.FieldNameDetail);

    let tolerance=1;

    //extract the detail data
    //find all occurences that match the reference field
    this.pdfDetails.forEach(referenceDetail => {

      if (!referenceDetail.IsDetailOn || !this.checkMatch(referenceInTemplate, referenceDetail, tolerance))
        return;

      //console.log(referenceDetail);
      //create a detail for this match
      let detail:any ={};
      detail[referenceName]=referenceDetail.Text;


      //now check ALL the details for the selected reference
      templateDetails.forEach(templateDetail => {
        let matchedDetails=this.pdfDetails.filter(det=>det.IsDetailOn && det!=referenceDetail && referenceDetail.Page==det.Page && this.checkY(referenceInTemplate, templateDetail, referenceDetail, det, tolerance)).forEach( matchedDetail =>{
          if (this.checkMatch(templateDetail, matchedDetail, tolerance))
          {
            detail[templateDetail.FieldNameDetail]=matchedDetail.Text; 
          }   
        });
      });


      result.Details.push(detail);
    });


    //console.log(result);

    return result;
  }

  findReferenceField(details: PdfDetail[]) : PdfDetail
  {
    let references=details.filter(det=>det.IsReference);

    if (references.length==0)
      return null;

    return references[0];  

  }

  findField(parameterName :string, details: PdfDetail[]) : PdfDetail
  {
    let matches=details.filter(det=>this.getParameterSwitch(det.Parameters, parameterName));

    if (matches.length==0)
      return null;

    return matches[0];  

  }

  setIsDetailOn(selectedDetails: PdfDetail[])
  {

    //check if the is a field with parameter 'detailOn'
    let templateHasADetailOn=(selectedDetails.filter(det=>this.getParameterSwitch(det.Parameters, "detailOn")).length>0);

    let previousPage=-1;
    let currentIsDetailOn=true;
    selectedDetails.forEach(det=>{
      if (det.Page!=previousPage)
      {
        currentIsDetailOn=templateHasADetailOn ? false : true;
      }

      if (this.getParameterSwitch(det.Parameters, "detailOn"))
        currentIsDetailOn=true;
      else if (this.getParameterSwitch(det.Parameters, "detailOff"))
        currentIsDetailOn=false;

      det.IsDetailOn=currentIsDetailOn;
      previousPage=det.Page;
    });
  }

  JsonToCsv(JSONData:any)
  {
    let resultAsCsv="";
    let headerData="";
    let sep="";
    this.pdfDetails.filter(p=>p.FieldNameHeader).forEach(det => {
      resultAsCsv+=det.FieldNameHeader+";";
      let value=JSONData[det.FieldNameHeader];
      headerData+=(value ? value : "")+";";
      sep=";"
    });

    let detailFields=this.pdfDetails.filter(det=>det.IsReference || det.FieldNameDetail);
    sep="";
    detailFields.forEach(detailField=>{
      resultAsCsv+=sep+((detailField.FieldNameDetail)?detailField.FieldNameDetail:"Reference");
      sep=";";
    })
    resultAsCsv+='\r\n';

    JSONData.Details.forEach(det=>{
      resultAsCsv+=headerData;
      sep="";
      detailFields.forEach(detailField=>{
        var value=det[((detailField.FieldNameDetail)?detailField.FieldNameDetail:"Reference")];
        //console.log(value);
        resultAsCsv+=sep+((value)?value:"");
        sep=";";
      })
      resultAsCsv+='\r\n';
    })
    //console.log(resultAsCsv);

    return resultAsCsv;
  }

  checkY(referenceInTemplate :PdfDetail, templateDetail: PdfDetail, referenceDetail: PdfDetail, detailToCheck : PdfDetail, tolerance: number) :boolean
  {
    let ignoreY=this.getParameterSwitch(templateDetail.Parameters,"ignoreY");

    if (ignoreY)
      return true;

    let actualToleranceY=tolerance;
    let parameterValue=this.getParameterValue(templateDetail.Parameters, "tol");
    if(parameterValue)
    {
      actualToleranceY=Number(parameterValue);;
    }
    parameterValue=this.getParameterValue(templateDetail.Parameters, "tolY");
    if(parameterValue)
    {
      //console.log(parameterValue);
      actualToleranceY=Number(parameterValue);
      //console.log("act "+actualToleranceY.toString());
    }

    return Math.abs((referenceInTemplate.Y-templateDetail.Y)-(referenceDetail.Y-detailToCheck.Y))<actualToleranceY;
  }

  checkMatch(referenceDetail: PdfDetail, detailToCheck : PdfDetail, tolerance: number) :boolean
  {


    let ignoreX=this.getParameterSwitch(referenceDetail.Parameters,"ignoreX");
    let ignoreFont=this.getParameterSwitch(referenceDetail.Parameters,"ignoreFont");
    if (!ignoreFont && referenceDetail.Font!=detailToCheck.Font)
      return false;

    let ignoreFontSize=this.getParameterSwitch(referenceDetail.Parameters,"ignoreFontSize");
    if (!ignoreFontSize && referenceDetail.Size!=detailToCheck.Size)
      return false;


    let actualToleranceX=tolerance;
    let parameterValue=this.getParameterValue(referenceDetail.Parameters, "tol");
    if(parameterValue)
    {
      actualToleranceX=Number(parameterValue);
    }

    parameterValue=this.getParameterValue(referenceDetail.Parameters, "tolX");
    if(parameterValue)
    {
      actualToleranceX=Number(parameterValue);
    }


    switch(referenceDetail.Alignment)
    {
      case "right":
        if (Math.abs(referenceDetail.XTo-detailToCheck.XTo)>actualToleranceX)
          return false;
        break;
      case "center":
        return false; //todo
        //break;
      default:
        if (Math.abs(referenceDetail.XFrom-detailToCheck.XFrom)>actualToleranceX)
          return false;
    }


    if (referenceDetail.Parameters!=undefined)
    {
      let patt1=/regex\s+(.+)\S?/;
      let regexesFound=referenceDetail.Parameters.match(patt1);

      if (regexesFound!=undefined)
      {
        let patt2=new RegExp(regexesFound[1]);
        if (!patt2.test(detailToCheck.Text))
            return false;
      }
    }
    return true;
  }

  getParameterValue(parameters:string, parameterName : string) : string
  {
    if (!parameters)
      return "";

    //console.log(parameterName+" in "+parameters);
    let patt1=new RegExp(parameterName+"\\s+(.+?)", "i");
    
    let regexesFound=parameters.match(patt1);

    if (regexesFound!=undefined)
    {
      //console.log("Found "+regexesFound[1]);
      return regexesFound[1];
    }
    else
      return "";
  }

  getParameterSwitch(parameters:string, parameterName : string) : boolean
  {
    if (!parameters)
      return false;

    let patt1=new RegExp(parameterName,"i");

    let regexesFound=parameters.match(patt1);

    if (regexesFound!=undefined)
    {
      return true;
    }
    else
      return false;
  }

  pdfDetails : PdfDetail[];

  onFileChange(event) {

    if (this.pdfDetails!=undefined)
      var savedDetails=Object.assign([], this.pdfDetails);

    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      this.fileName=file.name;
      // reader.readAsDataURL(file);
      // reader.onload = () => {
        // this.form.get('avatar').setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: reader.result.split(',')[1]
        // })

        let formData:FormData = new FormData();
        formData.append('degree_attachment', file,  this.fileName);
        let headers = new HttpHeaders();
        headers.append('Accept', 'application/pdf');
    
        this.http.post("http://pdftotableapi.pascaldeclercq.be/api/upload", formData, {headers: headers}).subscribe((data : PdfDetail[])=> {
          this.pdfDetails=data;
          //console.log( this.pdfDetails);
          //console.log(this.pdfDetails);
          //apply the saved template to the new document
          if (savedDetails!=undefined)
          {
            let tolerance=1;

            let savedDetailOn=this.findField("detailOn",savedDetails);
            if (savedDetailOn)
            {
              let newDetailOns=this.pdfDetails.filter(savedDetail=>this.checkMatch(savedDetailOn, savedDetail, tolerance));
              if (newDetailOns.length>0)
              {
                newDetailOns[0].Parameters=savedDetailOn.Parameters;
              }
            }

            let savedDetailOff=this.findField("detailOff",savedDetails);
            if (savedDetailOff)
            {
              let newDetailOffs=this.pdfDetails.filter(savedDetail=>this.checkMatch(savedDetailOff, savedDetail, tolerance));
              if (newDetailOffs.length>0)
              {
                newDetailOffs[0].Parameters=savedDetailOff.Parameters;
              }
            }
            this.setIsDetailOn(this.pdfDetails);

            let savedReference=this.findReferenceField(savedDetails);

            let newReferences=this.pdfDetails.filter(savedDetail=>savedDetail.IsDetailOn && this.checkMatch(savedReference, savedDetail, tolerance));
            let newReference=null;
            if (newReferences.length>0)
            {
              newReference=newReferences[0];
              newReference.IsReference=true;
              newReference.FieldNameDetail=savedReference.FieldNameDetail;
              newReference.Parameters=savedReference.Parameters;
              newReference.Alignment=savedReference.Alignment;

              //todo: search for detailfields
              savedDetails.filter(det=>det.FieldNameDetail).forEach(savedDetail=>{

                this.pdfDetails.forEach(detailField => {  
                  if (this.checkMatch(savedDetail, detailField, 1) && this.checkY(newReference, detailField, savedReference, savedDetail, 1))
                  {
                    detailField.FieldNameDetail=savedDetail.FieldNameDetail;
                    detailField.Parameters=savedDetail.Parameters;
                    detailField.Alignment=savedDetail.Alignment;
                    //console.log("found detail in new "+detailField);
                  }
                });
              });
            }



            //Headerfields
            savedDetails.filter(savedDetail => !savedDetail.IsReference && savedDetail.FieldNameHeader).forEach(savedHeaderField =>{
              this.pdfDetails.forEach(newDetail=>{
                //console.log("3 "+newDetail.Text)
    
                  let ignoreY=this.getParameterValue(savedHeaderField.parameters, "ignoreY");

                  if (this.checkMatch(savedHeaderField, newDetail, 1) && (ignoreY || savedHeaderField.Y==newDetail.Y))
                  {
                    //console.log(newDetail.Y);
                    newDetail.FieldNameHeader=savedHeaderField.FieldNameHeader;
                    newDetail.FieldNameDetail=savedHeaderField.FieldNameDetail;
                    newDetail.Parameters=savedHeaderField.Parameters;
                    newDetail.Alignment=savedHeaderField.Alignment;
                    //console.log("4 "+newDetail.Text)
    
                  }
                });
              });
            }
          })
          
        }
      else
      {
        this.pdfDetails=undefined;
      }
      // };

    
    }

  }

